import React from "react";

function RefundPolicy() {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy-in">
        <h1>Return and Refund Policy</h1>
        <p>
          We have established this policy to ensure that you understand our
          refund and return process clearly. This policy is applicable to
          customers in India.
        </p>

        <h2>Return Request Period</h2>
        <p>
          If you wish to initiate a return, you must submit a request within{" "}
          <strong>48 hours</strong> of receiving your product. Requests received
          after this period may not be accepted.
        </p>

        <h2>Damaged Product</h2>
        <p>
          If you receive a damaged product, you must provide an unboxing video
          showing the damage. This evidence is crucial for us to assess the
          issue and offer the best resolution.
        </p>

        <h2>Missing Items</h2>
        <p>
          If any item is missing from your order, please provide an unboxing
          video displaying the received items. Notify us within{" "}
          <strong>48 hours</strong> of delivery, and we will investigate the
          issue. If confirmed, a refund will be issued for the missing item(s).
        </p>

        <h2>Exchange for Wrong Product</h2>
        <p>
          If you ordered the wrong product and wish to exchange it, please note:
        </p>
        <ul>
          <li>
            The shipping cost for returning and resending the product is your
            responsibility.
          </li>
          <li>
            We are a wholesale website, and not a retail one, so exchanges are
            limited.
          </li>
          <li>Contact our customer support team for further instructions.</li>
        </ul>

        <h2>Custom-Printed Products Policy</h2>
        <h3>a. Order Cancellation</h3>
        <p>
          Orders for custom-printed products <strong>cannot be canceled</strong>{" "}
          after placement due to production costs and customization.
        </p>

        <h3>b. Undeliverable Shipments</h3>
        <p>
          If a shipment is undeliverable, we will attempt redelivery through an
          alternative courier service. However, returns will not be accepted.
        </p>

        <h2>Delayed Deliveries</h2>
        <p>
          If delivery is delayed beyond the usual timeframe (1-2 months due to
          courier issues), we will work with the courier to resolve concerns.
        </p>
        <p>
          We recommend tracking your order regularly and contacting us if there
          are no updates within 15 days of dispatch.
        </p>

        <h2>Exceptions</h2>
        <p>
          We are not responsible for unreported damages or claims made outside
          the given timelines. These measures align with courier regulations.
        </p>

        <h2>Refund Eligibility</h2>
        <ul>
          <li>
            <strong>Damaged or Defective Products:</strong> Refunds will be
            processed after verifying damage through video proof.
          </li>
          <li>
            <strong>Missing Items:</strong> If we cannot provide the missing
            item, a refund will be issued.
          </li>
        </ul>

        <h2>Return Conditions</h2>
        <ul>
          <li>
            Products must be in original condition, unused, and undamaged.
          </li>
          <li>
            All original packaging, accessories, and tags must be included.
          </li>
        </ul>

        <h2>Return Shipping</h2>
        <p>
          Return shipping costs are the customer's responsibility unless the
          return is due to our error (e.g., wrong or damaged item).
        </p>

        <h2>Rejection/Denial of Parcel Policy</h2>
        <p>
          If a customer rejects or denies accepting the parcel after dispatch,
          the following deductions will apply:
        </p>
        <ul>
          <li>
            <strong>Shipping Charge:</strong> 2 times the original shipping
            charge will be deducted (includes both forward and reverse
            shipping).
          </li>
          <li>
            <strong>Packing Charge:</strong> 10% of the product value will be
            deducted as a packing charge.
          </li>
        </ul>
        <p>These deductions will be applied before issuing a refund.</p>

        <h2>Refund Process</h2>
        <p>
          Once we receive and inspect your return, we will notify you of the
          approval or rejection of your refund. If approved, refunds will be
          delivered within <strong>7 days</strong> to the original payment
          method.
        </p>

        <h2>Return Processing</h2>
        <p>The return will be processed only if:</p>
        <ul>
          <li>The refund will be delivered within 7 days to the original payment
          method.</li>
          <li>The product was not damaged while in your possession.</li>
          <li>The product matches what was shipped to you.</li>
          <li>The product is in original condition.</li>
          <li>An unboxing video is provided.</li>
        </ul>

        <h2>Refund Conditions</h2>
        <p>Refunds are only possible if:</p>
        <ul>
          <li>The product is unused and undamaged.</li>
          <li>It is returned with original packaging, receipt, and invoice.</li>
          <li>
            Refunds will be processed only after the product reaches our
            premises and is verified.
          </li>
        </ul>

        <h2>Discrepancies in Product</h2>
        <p>
          If the product received does not match the description on our site or
          does not meet your expectations, contact our customer service within{" "}
          <strong>24 hours</strong> of receiving it.
        </p>
        <p>
          Our Customer Service Team will review your complaint and take
          appropriate action.
        </p>

        <h2>Contact Us</h2>
        <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
    <p>Name: CGTHomes </p>
    <p>Email: info@cgthomes.com</p>
    <p>Company Email: support@cgthomes.com</p>
    <p>Company Address: Street No 3, DLF Cyber City Hyderabad, telengana</p>
      </div>
    </div>
  );
}

export default RefundPolicy;
